import background_icon_raw from '../../../../frontend/phi3d/src/assets/img/SVG_icons/Bottom/visualisation/backgrounds.svg';
import consistency_checks_raw from '../../../../frontend/phi3d/src/assets/img/SVG_icons/Top/search/consistency_checks.svg';

export const BackgroundsIcon = background_icon_raw;
export const ConsistencyChecksIcon = consistency_checks_raw;
